export const ApiNameList = {
    restApi: {
        baseUrl: '/',
        login: 'public/api/asa/user/login',
        logout: 'public/api/asa/user/logout',
        refreshToken: 'secure/api/asa/user/refreshToken',
        createUser: 'public/api/asa/user/register',
        createMicrositeUser: 'public/api/asa/user/registerMicrositeUser',
        detailsUpdate: 'public/api/asa/user/forgotPassword',
        resetPassword: 'public/api/asa/user/resetPassword',
        landing: 'public/api/asa/student/landing',
        campusLanding:'public/api/asa/student/campusLanding',
        manageMicrositeDashboard: 'secure/api/asa/student/manageMicrositeDashboard',
        deleteFile: 'secure/api/asa/student/deleteFile',
        getFiles: 'secure/api/asa/student/getFiles',
        uploadFile: 'secure/api/asa/student/uploadFile',
        downloadFile: 'secure/api/asa/student/downloadFile',
        enrollmentStatus: 'secure/api/asa/student/enrollmentStatus',
        myDetails: 'secure/api/asa/student/studentInfo',
        updateMyDetails: 'secure/api/asa/student/updateEnrollment',
        updateAllDetails: 'secure/api/asa/student/updateAllEnrollment',
        getUserAccount: 'secure/api/asa/student/getUserAccount',
        updateUserAccount: 'secure/api/asa/student/updateUserAccount',
        changePassword: 'secure/api/asa/user/changePassword',
        getConfigData: 'secure/api/asa/common/getConfigData',
        getUserEnrollments: 'secure/api/asa/student/enrollments',
        getInsuranceCarriers: 'secure/api/asa/student/getCarriers',
        getWaiverInfo: 'secure/api/asa/student/waiverInfo',
        initEnrollment: 'secure/api/asa/student/initEnrollment',
        getDependents: 'secure/api/asa/common/getDependents',
        updateDependent: 'secure/api/asa/common/updateDependent',
        enrollmentInfo: 'secure/api/asa/student/enrollmentInfo',
        addressValidation: 'secure/api/asa/student/verifyAddress',
        manageDependents: 'secure/api/asa/student/manageDependents',
        paymentInfo: 'secure/api/asa/student/paymentInfo',
        enrollmentReview: 'secure/api/asa/student/enrollmentReview',
        validateWaiver: 'secure/api/asa/student/validateWaiver',
        waiverReview: 'secure/api/asa/student/waiverReview',
        submitWaiver: 'secure/api/asa/student/submitWaiver',
        planStatus: 'secure/api/asa/common/planStatus',
        submitEnrollment: 'secure/api/asa/student/submitEnrollment',
        downloadReceipt: 'secure/api/asa/student/getEnrollReceipt',
        submitDepEnrollment: 'secure/api/asa/student/submitDepEnrollment',
        enrollmentHistory: 'secure/api/asa/student/getEnrollHistory',
        getEnrollmentById: 'secure/api/asa/student/getEnrollmentById',
        getInsuranceDetail: 'secure/api/asa/student/getInsuranceDetail',
        reValidateWaiver: 'secure/api/asa/student/reValidateWaiver',
        validateToken: 'public/api/asa/user/validateToken',
        micrositeEnrollmentHistory: 'secure/api/asa/student/micrositeEnrollmentHistory',
        getParticipationIdStudentId: 'secure/api/asa/student/getParticipationIdStudentId',
        getFileLabelFormat: 'secure/api/asa/student/getFileLabelFormat',
        getUserId: 'public/api/asa/user/verify',
        authorizeOkta: 'secure/api/asa/user/authorizeOkta',
        getOktaUserId:'public/api/asa/common/getOktaUserId',
        getOktaGroups:'public/api/asa/common/getOktaGroups',
        getOktaMfaFactors:'public/api/asa/common/getOktaMfaFactors',
        getOktaMfaSendOtp:'public/api/asa/common/getOktaMfaSendOtp',
        getOktaMfaVerifyOtp:'public/api/asa/common/getOktaMfaVerifyOtp',
        resetOktaPassword:'public/api/asa/common/resetOktaUserPassword',
        changePasswordOkta:'secure/api/asa/common/changeOktaPassword',
    }
};
